module.exports = __webpack_public_path__ + "img/mars-stroke-up.2ca63b2d.svg";